/*
    ---- Globals ----
    Global muteable vars
*/

import React from 'react';
let GlobalsContext;
let { Provider } = (GlobalsContext = React.createContext())
export const useGlobals = () => React.useContext(GlobalsContext)


export default function Globals(props) { 
    // wrap component in a provider. 
    return <Provider value={props.value}>{props.children}</Provider>
}


